export function formatAsMoney(value: number | string) {
  // Convert the number to a string and split it into whole and decimal parts
  const parts = value.toString().split(".");

  // Format the whole part with commas for thousands separators
  const wholePart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  // Combine the whole and decimal parts back together
  if (parts.length === 2) {
    return `${wholePart}.${parts[1].slice(0, 2)}`;
  } else {
    return wholePart;
  }
}

export function maskBalance(balance: number) {
  const strBalance = balance.toString();
  return "*".repeat(strBalance.length); // Adds ₦ symbol if needed
}

/**
 * Read an amount the API may send as a number or as a formatted string
 * ("4,624,430.00" — the profile endpoint's `wallet.available_balance`).
 */
export function parseMoney(value: unknown): number {
  if (typeof value === "number") return Number.isFinite(value) ? value : 0;
  if (typeof value !== "string") return 0;
  const parsed = Number(value.replace(/[^\d.-]/g, ""));
  return Number.isFinite(parsed) ? parsed : 0;
}
